import React, { useState } from 'react';
import { PH3Text, Input, InputWrapper, LabelText, FlexContainer, SelectBox, DescriptionText } from "../../../design";
import SimpleReactValidator from 'simple-react-validator';
import Select from 'react-select'
import { COUNTRY_PHONE_CODE } from "../../../appconstants";
import { isValidPhoneNumber } from 'libphonenumber-js';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFormData } from '../../../redux/appConfigInfo';
import { SpError } from '../../../widgetDesign';
import { Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { setCustomerDetails, setUpdateStatus } from '../../../redux/customerDetailsInfo';
import { setDirectoryEligibility, setDirectoryPaymentMethods } from '../../../redux/directory';
import { LookUpDirectory } from '../../SavedPaymentMethods/EndPoints';

type Props = {
  setCustomerExist: Function,
}

const CustomerDetails = (props: Props) => {
  const { setCustomerExist } = props;
  const { formData } = useSelector((store) => store.appConfigInfo);
  const dispatch = useDispatch();
  const [, forceUpdate] = useState();
  const COMP_CODE = 'CUSTOMER_DETAIL';
  const DISABLE_BG_COLOR = '#E8ECED';
  const DISABLE_COLOR = '#6A6A6A';

  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      phoneNumValidation: {
        message: 'The phone number is invalid',
        rule: (val, param) => (isValidPhoneNumber(param[0])),
      },
      nameValidation: {
        message: 'The name should be minimum 5 characters',
        rule: (val) => {
          if (!val) return false;
          const trimmedName = val.trim();
          return trimmedName.length >= 5;
        },
      },
      checkLowerCase: {
        message: 'Email address must not contain uppercase letters.',
        rule: (val) => val === val.toLowerCase(),
      },
    },
  }));

  const phoneCustomStyles = {
    container: base => ({
      height: '41px',
      width: '100px !important',
    }),
    control: base => ({
      ...base,
      height: '39px',
      minHeight: '39px',
      width: '100px !important',
      border: 'none',
      borderRight: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
      background: formData[COMP_CODE]?.disablePhone ? DISABLE_BG_COLOR : 'white',
      color: formData[COMP_CODE]?.disablePhone ? DISABLE_COLOR : 'inherit',
    }),
  };

  const customInputStyle = {
    borderColor: '#CCCCCC',
    width: '100%',
    height: '41px',
    paddingLeft: '15px',
  };

  const customLabelStyle = {
    color: 'black'
  };

  const customRowFlexContainerProps = {
    xs: '100%',
    md: '100%',
    gap: '5%',
  };

  const customColFlexContainerProps = {
    xs: '100%',
    md: '47.5%',
    flexDirection: 'col',
  };

  const submit = (event) => {
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }

    const payload = {
      name: formData[COMP_CODE]?.name,
      email: formData[COMP_CODE]?.email,
      phoneNumber: formData[COMP_CODE]?.phoneNumber ? `${formData[COMP_CODE]?.countryCode}${formData[COMP_CODE]?.phoneNumber}` : null
    }

    dispatch(LookUpDirectory(payload));
    dispatch(setDirectoryPaymentMethods([]));
    dispatch(setCustomerDetails(payload));
    dispatch(setUpdateStatus(true));
    setCustomerExist(true);
    dispatch(setDirectoryEligibility(true));
  };

  return (
    <FlexContainer className="mb-4">
      <FlexContainer {...customRowFlexContainerProps}>
        <FlexContainer {...customColFlexContainerProps}>
          <LabelText style={{...customLabelStyle}}>
              Name <span style={{ color: 'red' }}>*</span>
          </LabelText>
          <Input
            style={{
              ...customInputStyle,
              background: formData[COMP_CODE]?.disableName ? DISABLE_BG_COLOR : 'white',
              color: formData[COMP_CODE]?.disableName ? DISABLE_COLOR : 'inherit',
            }}
            placeholder="Enter your name"
            onChange={(e) => {
              dispatch(setFormData({ code: COMP_CODE, value: { ...formData[COMP_CODE], name: e.target.value } }))
            }}
            value={formData[COMP_CODE]?.name || ''}
            readOnly={formData[COMP_CODE]?.disableName}
          />
          <SpError>
            {simpleValidator.current.message('name', formData[COMP_CODE]?.name, 'required')}
          </SpError>
        </FlexContainer>
        <FlexContainer {...customColFlexContainerProps}>
          <LabelText style={{...customLabelStyle}}>
            E-Mail <span style={{ color: 'red' }}>*</span>
          </LabelText>
          <Input
            placeholder="Enter your email"
            type="email"
            style={{
              ...customInputStyle,
              background: formData[COMP_CODE]?.disableEmail ? DISABLE_BG_COLOR : 'white',
              color: formData[COMP_CODE]?.disableEmail ? DISABLE_COLOR : 'inherit',
            }}
            onChange={(e) => {
              dispatch(setFormData({ code: COMP_CODE, value: { ...formData[COMP_CODE], email: e.target.value } }))
            }}
            value={formData[COMP_CODE]?.email || ''}
            readOnly={formData[COMP_CODE]?.disableEmail}
          />
          <SpError>
            {simpleValidator.current.message('Email', formData[COMP_CODE]?.email, 'required|email|checkLowerCase')}
          </SpError>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer {...customRowFlexContainerProps}>
        <FlexContainer {...customColFlexContainerProps}>
          <LabelText style={{...customLabelStyle}}>
            Phone <span style={{ color: 'red' }}>*</span>
          </LabelText>
          <InputWrapper
            display="flex"
            marginTop="8px"
            style={{
              ...customInputStyle,
              paddingLeft: 0,
              // readOnly style
              background: formData[COMP_CODE]?.disablePhone ? DISABLE_BG_COLOR : 'white',
              color: formData[COMP_CODE]?.disablePhone ? DISABLE_COLOR : 'inherit',
            }}
          >
            <Select
              getOptionLabel={(option) => option.value}
              isSearchable={!formData[COMP_CODE]?.disablePhone}
              menuIsOpen={formData[COMP_CODE]?.disablePhone ? false : undefined}
              styles={phoneCustomStyles}
              options={COUNTRY_PHONE_CODE.map(value => { return { value } })}
              onChange={(e) => {
                dispatch(setFormData({ code: COMP_CODE, value: { ...formData[COMP_CODE], countryCode: e.value } }))
              }}
              readOnly={formData[COMP_CODE]?.disablePhone}
              value={{ value: formData[COMP_CODE]?.countryCode || '' }}
            />
            <Input
              placeholder="Enter your phone number"
              style={{
                border: 'none',
                // readOnly style
                background: formData[COMP_CODE]?.disablePhone ? DISABLE_BG_COLOR : 'white',
                color: formData[COMP_CODE]?.disablePhone ? DISABLE_COLOR : 'inherit',
              }}
              onChange={(e) => 
                dispatch(setFormData({ code: COMP_CODE, value: { ...formData[COMP_CODE], phoneNumber: e.target.value } }))
              }
              readOnly={formData[COMP_CODE]?.disablePhone}
              value={formData[COMP_CODE]?.phoneNumber || ''}
            />
          </InputWrapper>
        </FlexContainer>
      </FlexContainer>
      <SpError>
        {simpleValidator.current.message('Country Code', formData[COMP_CODE]?.countryCode, 'required')}
      </SpError>
      <SpError>
        {simpleValidator.current.message('Phone Number', formData[COMP_CODE]?.phoneNumber, `required|phoneNumValidation:${formData[COMP_CODE]?.countryCode}${formData[COMP_CODE]?.phoneNumber}`)}
      </SpError>
      <FlexContainer className="mt-4" {...customRowFlexContainerProps}>
        <FlexContainer className="d-flex align-items-end justify-content-end w-100" {...customColFlexContainerProps}>
          <Button type="primary" icon={<ArrowRightOutlined />} onClick={submit}>Next</Button>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default CustomerDetails;
